import { StarsButton } from '@ps/web-shared-components';
import { addSeconds, format } from 'date-fns';
import React, { useEffect } from 'react';

import useTimer from '@swf/core/hooks/useTimer';

import { TXTWCL_Resend_in_N0 } from './ResendButton.messages.json';

interface Props {
  countdown: number;
  setCountdown: (time: number) => void;
  block?: boolean;
  hideHoursFormat?: boolean;
}

const modifier = (s: number) => s - 1;

const formatTime = (s: number, hideHours?: boolean): string => {
  let formatType = '00:mm:ss';
  if (hideHours) {
    formatType = 'mm:ss';
  }

  return format(addSeconds(new Date(0), s), formatType);
};

const ResendButton: React.FC<Props> = ({
  countdown: initial,
  setCountdown,
  block = false,
  hideHoursFormat = false
}) => {
  const timer = useTimer({ modifier, initial });

  useEffect(() => {
    if (timer < 0) {
      setCountdown(0);
    }
  }, [setCountdown, timer]);

  return (
    <StarsButton
      block={block}
      variant="secondary"
      translation={TXTWCL_Resend_in_N0}
      values={{ 0: formatTime(timer, hideHoursFormat) }}
      disabled
    />
  );
};

export default ResendButton;
